function getParent(parent) {
	let $parent

	if (typeof(parent) === 'string') {
		let $p = document.querySelector(parent)
		if ($p) $parent = $p
	} else  if (typeof(parent) === 'object' && 'nodeName' in parent) {
		$parent = parent
	}

	return $parent
}

export function getEl(elID, parent) {
	let $parent = getParent(parent)

	if (!$parent) {
		if (parent) {
			console.warn(`$(${elID}): parent(${parent} provided but is not a valid selector or element`)
		}
		$parent = document
	}

	return $parent.querySelector(elID)
}

export function getAllEl(elID, parent) {
	let $parent = getParent(parent)

	if (!$parent) {
		if (parent ) {
			console.warn(`$$(${elID}): parent(${parent} provided but is not a valid selector or element`)
		}

		$parent = document
	}

	return $parent.querySelectorAll(elID)
}

export function domIsSettled() {
	return new Promise((resolve, reject) => {
		requestAnimationFrame(() => {
			setTimeout(() => {
				resolve();
			}, 0);
		});
	})
}

/**
 * removeElementByID
 * Removes a DOM element by its ID. does nothing if id isn't found
 * @param {string} id - The ID of the element to remove
 *
 * */
/**
 * formatNumber
 * Formats a number with locale-aware separators and decimal places
 * @param {number} n - The number to format
 * @param {number} [minDecimals=0] - Minimum fraction digits
 * @param {number} [maxDecimals=2] - Maximum fraction digits
 * @returns {string}
 */
export function formatNumber(n, minDecimals = 0, maxDecimals = 2) {
	return Number(n).toLocaleString(undefined, {
		minimumFractionDigits: minDecimals,
		maximumFractionDigits: maxDecimals,
	})
}

export function removeElementByID(id) {
	domIsSettled().then(() => {
		const el = document.querySelector(`#${id}`)
		if (el) el.remove()
	})
}
